import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { patchAppointment } from 'actions/appointments';
import Button from 'atoms/button';
import Icon from 'atoms/icon';
import TextArea from 'atoms/text-area';
import toast from 'atoms/toast';
import { requestFulfilled, requestOngoing } from 'store/reducers/ui';

export default function Notes({ isEditable = true }) {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const appointment = useSelector((state) => state.appointment);
  const {
    uuid,
    animal,
    location,
    locationUser,
    service,
    dateStart,
    note,
    isLoading,
  } = appointment;
  const [editedNote, setEditedNote] = useState(note);

  const onSaveNote = () => {
    if (isEditable && !!appointment && !isLoading) {
      dispatch(requestOngoing());
      dispatch(
        patchAppointment(uuid, {
          uuid: {
            animal: animal?.uuid,
            location: location?.uuid,
            location_user: locationUser?.uuid,
            service: service?.uuid,
          },
          date_start: dateStart,
          note: editedNote,
        })
      ).then(({ success }) => {
        if (success) {
          toast({ text: 'Note saved!' });
        }
        setIsEditing(false);
        dispatch(requestFulfilled());
      });
    }
  };

  return (
    <div className="notes-panel flex-column mb-12 p-24 border-light-purple radius-24">
      <div className="flex-row justify-between mb-15">
        <h4>Notes</h4>
        {isEditable && !isEditing && (
          <Icon
            name="pencil"
            className="ml-8"
            onClick={() => setIsEditing(true)}
          />
        )}
      </div>
      {!isEditing &&
        (editedNote ? (
          <p className="f13 pre-line">{editedNote}</p>
        ) : (
          <p className="f13 c-primary-purple">Add a custom note</p>
        ))}
      {isEditable && isEditing && (
        <>
          <TextArea
            value={editedNote}
            setValue={setEditedNote}
            autoFocus
            placeholder="Add a custom note"
          />
          <Button
            text="Save note"
            size="medium"
            variant="white-outlined"
            className="w-fit mt-32"
            onClick={onSaveNote}
          />
        </>
      )}
    </div>
  );
}
